import * as types from '../../../configs/constants/actionType'
import { takeLatest } from 'redux-saga/effects'
import generateActions from '../../actions/actions'
import {
  eaiLicenseListSagaByPage,
  eaiLicenseImportSaga,
  getValueDropdownSaga,
  deactivateEAILicenseSaga,
  syncEAILicensesSaga
} from './eaiLicenseListSaga'

const eaiLicenseList = [
  takeLatest(generateActions(types.EAI_LICENSE_LIST).REQUEST, eaiLicenseListSagaByPage),
  takeLatest(generateActions(types.EAI_LICENSE_IMPORT).REQUEST, eaiLicenseImportSaga),
  takeLatest(generateActions(types.EAI_LICENSE_DROPDOWN).REQUEST, getValueDropdownSaga),
  takeLatest(generateActions(types.DEACTIVATE_EAI_LICENSE).REQUEST, deactivateEAILicenseSaga),
  takeLatest(generateActions(types.SYNC_EAI_LICENSE).REQUEST, syncEAILicensesSaga)
]
export default eaiLicenseList
